import React, { useContext } from "react"
import get from "lodash.get"

import { Mileage } from "../../components/mileage/Mileage"
import { TextLink } from "../../components/common/TextLink/TextLink"
import { AdditonalFeature } from "./AdditionalFeature/AdditionalFeature"
import { Registration } from "../../components/registration/Registration"
import { AppContext, AppContextInterface } from "../../state/ContextProvider"
import { selectVehicleDetails } from "../../state/selectors/vehicleDetails"
import { ConfirmVehicleLoader } from "../Loaders"

const YourVehicle: React.FC = () => {
  const {
    state: { vehicleDetails, mileage },
  } = useContext(AppContext) as AppContextInterface

  const formattedVehicleDetails = selectVehicleDetails(vehicleDetails)

  if (
    // Wait on the data
    !get(vehicleDetails, "requestResultsType", 0)
  ) {
    return <ConfirmVehicleLoader />
  }

  const {
    makeAndModel,
    derivative,
    previousOwners,
    additionalFeatures,
    defaultCapImageUrl,
  } = formattedVehicleDetails as any

  const element = (e: any) => {
    return e.target as HTMLElement
  }

  const filteredFeatures = additionalFeatures?.filter(
    (feature: any) => feature !== ""
  )

  return (
    <div className="your-vehicle-page main">
      <div className="vehicle-image">
        {defaultCapImageUrl ? (
          <>
            <img
              alt={makeAndModel}
              src={defaultCapImageUrl}
              onError={(e) => (element(e).style.display = "none")}
            />
            <p className="image-paragraph">
              Image for illustration purposes only
            </p>
          </>
        ) : null}
        <Registration />
      </div>
      <div className="your-vehicle-container">
        <div className="inner-container">
          <div className="vehicle-info">
            <div className="content">
              <h2 data-testid="lkr-makeandmodel">{makeAndModel}</h2>
              <p data-testid="lkr-derivative" className="derivative">
                {derivative}
              </p>
              <p data-testid="lkr-othertitle" className="climate-controls">
                {previousOwners}
              </p>
              <div className="feature-container">
                {filteredFeatures?.map((feature: string) => (
                  <AdditonalFeature key={feature} feature={feature} />
                ))}
              </div>
            </div>
            <Mileage
              mileage={mileage}
              text={"Mileage"}
              shouldRenderButton={true}
            />
            <TextLink
              data-testid="lkr-change-vehicle"
              text="Change vehicle"
              href="/"
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default YourVehicle
